const imageGallery = document.querySelectorAll('[data-slider="image-gallery__slider"]');

const imageGalleryOptions = {
  slidesPerView: 'auto',
  spaceBetween: 4,
  speed: 800,
  loop: true,
  centerInsufficientSlides: true,
  centeredSlides: true,
  centeredSlidesBounds: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  mousewheel: {
    forceToAxis: true,
  },
};

imageGallery.forEach((el) => {
  const parentElem = el.closest('.image-gallery');

  const arrowLeft = parentElem.querySelector('.swiper-button-prev');
  const arrowRight = parentElem.querySelector('.swiper-button-next');

  imageGalleryOptions.navigation.prevEl = arrowLeft;
  imageGalleryOptions.navigation.nextEl = arrowRight;

  new Swiper(el, imageGalleryOptions);
});
